import { AppSettings } from "@core/types";

const aboutCompanyHtml = `Компания "Фортайм" – это ведущий магазин товаров для кондитеров в городе Грозный по Чеченской Республике. Мы предлагаем широкий ассортимент продукции, включая ингредиенты, декоративные элементы, инвентарь и упаковочные материалы, необходимые для создания изысканных кондитерских изделий.
<br />
Наш магазин является крупнейшим в регионе, что гарантирует нашим клиентам широкий выбор качественных товаров по конкурентоспособным ценам. Мы стремимся обеспечить наших клиентов всем необходимым для воплощения их кулинарных идей в жизнь.
<br />
Особенностью нашего сервиса является бесплатная доставка по городу Грозный при заказе от 3 тысяч рублей. Это делает покупки у нас еще более удобными и выгодными для наших клиентов.
<br />
Режим работы магазина "Фортайм" установлен с 8:00 до 18:30, что позволяет нашим клиентам совершать покупки в удобное для них время. Мы всегда рады видеть вас в числе наших клиентов и готовы обеспечить вас всем необходимым для вашего кондитерского мастерства.`;

export const Config: AppSettings = {
  exitAppICantGoBack: true,
  isOffertaPageEnabled: false,
  haveTabs: true,
  baseUrl: "https://proxy.fortime.staq.dev",
  CDNDomain: "oexzkrrjexltwvjqsmim.supabase.co",
  sharedData: {
    title: "4Time",
    text: `4Time - это ведущий магазин товаров для кондитеров в городе Грозный. Мы предлагаем широкий ассортимент продукции, включая ингредиенты, декоративные элементы, инвентарь и упаковочные материалы.\n\n`,
    androidUrl: "https://play.google.com/store/apps/details?id=ru.fortime.app",
    iosUrl: "https://apps.apple.com/ru/app/fortime/id6670272293",
  },
  newProductDuration: 20,
  expressMaxWeightKg: 0,
  privacyPolicyPageLink: "",
  showNewVersionAlert: false,
  showSendCustomerRequestButton: false,
  wishListIcons: true,

  minimumOrderAmount: 0,
  shouldCheckItemsAvailability: false,
  showProductReviews: true,
  showCouponsInCart: true,

  isBonusPointsEnabled: true,
  isDeliveryDateEnabled: true,
  orderHistoryPagination: true,
  isCustomerAdressesEnabled: true,
  isReferralEnabled: true,
  signUpPage: {
    nameFieldEnabled: false,
    lastNameFieldEnabled: false,
  },

  deleteAccountLink: "https://parhato.ru/delete-me/",
  // showSendCustomerRequestButton: true,
  cardProduct: true,
  updateUserForm: {
    isUpdatePasswordEnabled: true,
    showPhoneNumberInput: true,
  },
  isOnlinePaymentEnabled: false,
  // privacyPolicyPageLink: "https://parhato.ru/privacy/",
  isSeoOnHomePageEnabled: true,
  companyPhoneNumber: "+7 (967) 000-51-90",
  isContentInFooterShown: true,
  hasCardLoyalty: false,
  showSliderCatalogButton: false,
  addressSettings: {
    showCustomerAddresses: true,
    showFlatDelivery: false,
    addressInputDependsOnShippingMethod: false,
  },
  homePageCategories: {
    customersChoice: { title: "", isEnabled: true },
    featured: { title: "Featured Products", isEnabled: true },
    sale: { title: "On Sale Products", isEnabled: true },
    latest: { title: "Latest Addest", isEnabled: true },
  },
  showOrderPageProductCardCounter: false,
  cartMinAmountFromMethods: true,
  siteDomain: "fortime.staq.dev",

  loginPage: {
    phoneOrEmailFieldEnabled: true,
  },
  orderDetailPage: {
    reviewOrderEnabled: true,
    repeatOrderEnabled: true,
  },

  shipping: {
    isShippingZonesEnabled: false,
    showOldAddressInputOnShippingPage: true,
    showCurrentShippingAddressSelect: true,
    showDefaultShippingZone: false,
  },

  isExpressDeliveryEnabled: false,

  showStockQuantity: true,
  showStockStatus: true,
  lowStockThresholdToShowPercent: 10,
  minLowStockThresholdToShowNumber: 10,

  image: {
    isDownSizeEnabled: false,
    isLazyLoadingEnabled: false,
    base64Extension: "jpeg",
    isNeedBase65Prefix: true,
    isBase64InSrc: true,
  },
  appIosId: "",
  search: {
    minSearchLength: 3,
    inputDebounceTimeMs: 500,
  },
  usePriceHTML: false,
  headquarters: [43.338401, 45.696454],
  isNecessaryToCreateAddress: true,
  contacts: [
    {
      title: "WhatsApp",
      contact: "+7(967) 000-51-90",
      url: "https://wa.me/79670005190",
    },
    {
      title: "Эл. почта",
      contact: "zakaz@fortime.pro",
      url: "mailto:zakaz@fortime.pro",
    },
  ],
  requisites: [],
  aboutCompanyHtml: aboutCompanyHtml,
  defineSiteActivity: "это ведущий магазин товаров для кондитеров в городе Грозный, Чеченской Республике.",
  ignoredProductAttributes: ["Выгружать в мобильное приложение"],
  isUnavailableProductsEnabled: false,
  customerSurvey: {
    isEnabled: true,
    allowDismiss: false,
  },
  isStoriesEnabled: false,
  isInviteEnabled: false,
  hasClientToDeleteUser: true,
  isCardsEnabled: false,
  pages: {
    authPageName: "common",
    homePageName: "common",
    cartPageName: "common",
    myOrdersPageName: "common",
    myAccountPageName: "common",
    searchMainCategoriesPageName: "common",
    thankYouPageName: "common",
    subCategoriesPageName: "common",
    orderDetailPageName: "fortime",
    wishlistPageName: "common",
    productDetailPageName: "fortime",
  },
  isPaymentsEnabled: false,
  isSettingsPageEnabled: false,
  isEmailPushEnabled: false,
  isCartProgressButtonEnabled: false,
  isCartQuantityInputEnabled: false,
  isWeightProductQuantityStepEnabled: false,
  showUnavailableProductsModal: true,
  isImageInCartStoreEnabled: true,
  isShouldRecalculatePriceOnReplace: true,
  isToggleSwitchModuleEnabled: false,
  isCartSyncEnabled: true,
  shareProduct: false,
  imageUrlPrefix: "https://oexzkrrjexltwvjqsmim.supabase.co/storage/v1/object/public/",
  isReferralStatsEnabled: false,
  isAdditionalPageEnabled: false,
  maxWeightFeeStep: 10,
  showParentName: true,
  isDeliveryIntervalEnabled: false,
  isLocalNotificationsEnabled: false,
  isFCMNotificationsEnabled: true,
  staticOrderDataEnabled: false,
  appMetrica: {
    enabled: false,
    apiKey: "",
  },
  expressAllowedTimeStart: "10:00",
  expressAllowedTimeEnd: "23:59",
  isProductSubscriptionsEnabled: false,
  notifyPaymentText: "В ближайшие 30 минут вы получите уведомление для оплаты заказа",
  maxWeightForFeeKG: 0,
  extraWeightFee: 0,
  isWeightFeeEnabled: false,
  isOrderChatEnabled: true,
  stepForWeightProductQuantity: 0.1,
};
